class AuctionType {
    constructor(serverType, indicativePriceClassResolver) {
        this.serverType = serverType;
        this.indicativePriceClassResolver = indicativePriceClassResolver;
    }

    translate(t) {
        return t(`auctions.auction-type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(auctionType) {
        return auctionType === this;
    }

    resolveIndicativePriceClass(indicativePrice, auction) {
        return this.indicativePriceClassResolver(indicativePrice, auction);
    }
}

export const BUY = new AuctionType(
    'BUY',
    (indicativePrice, auction) => {
        let result = '';
        if (auction.lowestAcceptablePrice) {
            result = indicativePrice < auction.lowestAcceptablePrice ? 'not-ok' : 'ok';
        }
        return result;
    },
);
export const SELL = new AuctionType(
    'SELL',
    (indicativePrice, auction) => {
        let result = '';
        if (auction.highestAcceptablePrice) {
            result = indicativePrice > auction.highestAcceptablePrice ? 'not-ok' : 'ok';
        }
        return result;
    },
);

export const getAuctionType = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'BUY':
            result = BUY;
            break;
        case 'SELL':
            result = SELL;
            break;
        default:
            throw new Error(`Unknown auction type: ${serverType}`);
    }
    return result;
};

export const getAllAuctionTypes = () => [
    BUY,
    SELL,
];
